import React from 'react';
import clsx from 'clsx';

import Img from '@common/Image';
import Link from '@common/Link';

const ImageColourOverlay = ({ to, image, className, colour, children, ...other }) => {
  return (
    <Link
      to={to}
      className={clsx('d-flex flex-column position-relative rounded overflow-hidden scale-1-img', className)}
      {...other}
      >
      {image &&
        <Img
          loading='eager'
          image={image.gatsbyImageData}
          file={image.file}
          alt={image.description}
        />
      }
      <div
        className={clsx({[`bg-${colour}-gradient`]:colour})}
        style={{
          position:'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 99
      }}/>
      <div
        className='d-flex flex-column align-items-start justify-content-end p-3'
        style={{
          position:'absolute',
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 99
        }}>
        {children}
      </div>
    </Link>
  )
}

export default ImageColourOverlay
